"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcProjectGeneral = exports.FieldsetProjectGeneral = void 0;
const FieldsetProjectGeneral_yaml_component_1 = __importDefault(require("./FieldsetProjectGeneral.yaml?component"));
exports.FieldsetProjectGeneral = FieldsetProjectGeneral_yaml_component_1.default;
const UcProjectGeneral_yaml_component_1 = __importDefault(require("./UcProjectGeneral.yaml?component"));
exports.UcProjectGeneral = UcProjectGeneral_yaml_component_1.default;
